function initTinymce(selector, height, width) {
  tinymce.init({
    selector: selector,
    width: width != '' ? 'auto' : width,
    height: height != '' ? '370' : height,
    menubar: false,
    statusbar: false,
    plugins: [
      'advlist autolink lists link image charmap print preview anchor',
      'searchreplace visualblocks code fullscreen',
      'insertdatetime media table contextmenu paste textcolor'
    ],
    toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | forecolor backcolor | link'
  });
}

function initAddressPicker(addressTextSelector, mapDivSelector, latTextSelector, lngTextSelector) {
  // initialize default value for parameters
  mapDivSelector = typeof mapDivSelector !== 'undefined' ? mapDivSelector : null;
  latTextSelector = typeof latTextSelector !== 'undefined' ? latTextSelector : null;
  lngTextSelector = typeof lngTextSelector !== 'undefined' ? lngTextSelector : null;

  var addressTextField = $(addressTextSelector);

  var mapCenter = new google.maps.LatLng(3.157187, 101.7090264);
  if ((latTextSelector !== null) && (lngTextSelector !== null)) {
    if ($(latTextSelector).val() && $(lngTextSelector).val()) {
      mapCenter = new google.maps.LatLng($(latTextSelector).val(), $(lngTextSelector).val());
    }
  }

  // instantiate the addressPicker suggestion engine (based on bloodhound)
  var addressPicker = new AddressPicker({
    map: {
      id: mapDivSelector,
      zoom: 16,
      center: mapCenter
    },
    marker: {
      draggable: true,
      visible: true,
      position: mapCenter
    },
    autocompleteService: {
      componentRestrictions: {country: 'MY'}
    },
    reverseGeocoding: true
  });

  // instantiate the typeahead UI
  addressTextField.typeahead(null, {
    displayKey: 'description',
    source: addressPicker.ttAdapter()
  });

  // Bind some event to update map on autocomplete selection
  addressTextField.bind('typeahead:selected', addressPicker.updateMap);
  addressTextField.bind('typeahead:cursorchanged', addressPicker.updateMap);

  // Proxy inputs typeahead events to addressPicker
  addressPicker.bindDefaultTypeaheadEvent(addressTextField);

  // Listen for selected places result
  $(addressPicker).on('addresspicker:selected', function (event, result) {
    addressTextField.val(result.address());
    $(latTextSelector).val(result.lat());
    $(lngTextSelector).val(result.lng());
  });
}

//Dropzone.autoDiscover = false;
//
//jQuery.fn.extend({
//  getDropZone: function (uploadUrl, deleteUrl, getUrl, maxFile, id, layout, paramName) {
//    $(this).dropzone({
//      paramName: paramName,
//      maxFilesize: 4, //mb
//      uploadMultiple: false,
//      acceptedFiles: 'image/*',
//      url: uploadUrl,
//      maxFiles: maxFile, //0 is unlimited
//      previewTemplate: layout,
//      init: function () {
//        var thisDropZone = this;
//        var token = $('#_token').val();
//
//        this.on("removedfile", function (file) {
//          var form = {};
//          form[paramName + '_id'] = file.id;
//          form.table_id = id;
//          form._token = token;
//          console.log(form);
//          postAjax(deleteUrl, form);
//        });
//
//        this.on("success", function (file, response) {
//          file.id = response.imageId;
//        });
//
//        getAjax(getUrl, function (output) {
//          var image = output.imagesDetail;
//          if (image) {
//            for (var i = 0; i < image.length; i++) {
//              var file = {
//                name: image[i].name,
//                size: image[i].size,
//                id: image[i].id
//              };
//
//              thisDropZone.emit("addedfile", file);
//              thisDropZone.emit("complete", file);
//              thisDropZone.createThumbnailFromUrl(file, image[i].img_url);
//            }
//          }
//          thisDropZone.emit("reset");
//        });
//      }
//    });
//  }
//});

function getAjax(get_url, output) {
  $.ajax({
    type: "GET",
    url: get_url,
    dataType: "json",
    success: function (data, textStatus, xhr) {
      output(data);
    },
    error: function (xhr, ajaxOptions, thrownError) {
      output(xhr.responseJSON);
    }
  });
};

function postAjax(post_url, form, output) {
  $.ajax({
    type: "POST",
    url: post_url,
    dataType: "json",
    data: form,
    success: function (data, textStatus, xhr) {
      output(textStatus);
    },
    error: function (xhr, ajaxOptions, thrownError) {
      output(xhr.responseJSON);
    }
  });
};